import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@core/models/address/address.model';
import { TranslateService } from '@interticket/core';

@Pipe({
  name: 'address',
})
export class AddressPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(address: Address): string {
    if (!address) {
      return '';
    }
    const floorTranslation: string = this.translate.get('general_lang_floor');
    return address.bound(this.translate.currentLang, floorTranslation);
  }

}
